import { render, staticRenderFns } from "./PsychologyPaperPreview.vue?vue&type=template&id=4f33bcf0&scoped=true"
import script from "./PsychologyPaperPreview.vue?vue&type=script&lang=js"
export * from "./PsychologyPaperPreview.vue?vue&type=script&lang=js"
import style0 from "./PsychologyPaperPreview.vue?vue&type=style&index=0&id=4f33bcf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f33bcf0",
  null
  
)

export default component.exports